import { ref, onMounted, onBeforeUnmount } from 'vue';
import { MEDIA_BREAKPOINTS } from '@/js/constants';

function checkPortraitMode() {
  const { clientWidth, clientHeight } = document.documentElement;

  if (clientWidth < MEDIA_BREAKPOINTS.WIDTH.DESKTOP_S && clientHeight > MEDIA_BREAKPOINTS.HEIGHT.MOBILE) {
    return true;
  }

  return window.matchMedia('(orientation: portrait)').matches;
}

export default function useOrientation() {
  const isPortrait = ref(checkPortraitMode());

  function setPortraitMode() {
    isPortrait.value = checkPortraitMode();
  }

  onMounted(() => {
    if (window.screen.orientation) {
      window.screen.orientation.addEventListener('change', setPortraitMode);
    }
    window.addEventListener('orientationchange', setPortraitMode);
    window.addEventListener('resize', setPortraitMode);
  });

  onBeforeUnmount(() => {
    window.screen.orientation?.removeEventListener('change', setPortraitMode);
    window.removeEventListener('resize', setPortraitMode);
    window.removeEventListener('orientationchange', setPortraitMode);
  });

  return {
    isPortrait,
  };
}
